import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  const [params] = useSearchParams();
  const productId = params.get('product_id');
  const retryHref = productId ? `/checkout/${productId}` : '/';

  return (
    <div className="min-h-screen bg-[#05070d] text-white flex items-center justify-center p-6">
      <div className="text-center max-w-md" data-testid="payment-cancel">
        <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-4" />
        <h1 className="text-2xl font-black mb-2">No charge — checkout canceled.</h1>
        <p className="text-slate-400 text-sm mb-6">You can pick it back up anytime. No card was charged.</p>
        <div className="flex gap-3 justify-center">
          <Link to={retryHref} className="inline-flex items-center gap-2 px-5 py-3 rounded-xl bg-amber-400 text-black font-bold">
            Try again
          </Link>
          <Link to="/" className="inline-flex items-center gap-2 px-5 py-3 rounded-xl border border-white/15 text-white">
            <ArrowLeft className="w-4 h-4" /> Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
